import { render, staticRenderFns } from "./DialogExcellent.vue?vue&type=template&id=4e3978dd&"
import script from "./DialogExcellent.vue?vue&type=script&lang=js&"
export * from "./DialogExcellent.vue?vue&type=script&lang=js&"
import style0 from "./DialogExcellent.vue?vue&type=style&index=0&id=4e3978dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports